import i18n from '../i18n';

export const LANG_STORAGE_KEY = 'agentstation_lang';

export function appDateLocale(): string {
  return i18n.language === 'en' ? 'en-US' : 'th-TH';
}

export function languageButtonLabel(lang: string): string {
  return lang === 'en' ? 'EN' : 'ไทย';
}
